var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"OverviewColumn"},[_c('v-simple-table',{staticClass:"OverviewColumn__table"},[_c('thead',[_c('tr',{staticClass:"OverviewColumn__tableHead"},[_vm._t("title")],2)]),_c('tbody',[_vm._t("content")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }